import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, styled, Grid, IconButton, Divider } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import ButtonBlue from "../../../../shared/general/ButtonBlue";

import { getCompanyContract } from "../../../../../../actions/vendor";

import utils from "../../../../../../utils";

import DialogEdit from "./DialogEdit";
import DrawerEditSalary from "./drawerEditSalary";
import DrawerEditPaymentRound from "./drawerEditPaymentRound";

const StyledWrapTop = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
  "& .MuiTypography-body2": {
    margin: 0,
  },
});

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledDivider = styled(Divider)({
  marginTop: 16,
  marginBottom: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const StyledRoot = styled("div")({
  "& .salary": {
    "& .MuiTypography-h6": {
      marginRight: 8,
    },
    display: "flex",
    alignItems: "baseline",
  },
});

const StyledTextValue = styled(Typography)({
  fontSize: 18,
  "& i": {
    padding: 2,
  },
});

const Employment = (props) => {
  const { changeGroupTap, changeTabs } = props;
  const dispatch = useDispatch();
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );
  const { t, i18n } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);
  const [mode, setMode] = useState("");
  const [showPersonalId, setShowPersonalId] = useState(false);
  const [showSalaryBilling, setShowSalaryBilling] = useState(false);

  const [drawerEditSalaryConfig, setDrawerEditSalaryConfig] = useState({
    isOpen: false,
    data: {},
  })

  const [drawerEditPaymentRoundConfig, setDrawerEditPaymentRoundConfig] = useState({
    isOpen: false,
    data: {},
  })

  useEffect(() => {
    dispatch(getCompanyContract());
  }, []);

  const handleClick = (mode) => {
    console.log("handleClick");
    setOpenDialog(true);
    setMode(mode);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const changeTimeToDate = (time) => {
    let splitTime = time.split(":");
    return new Date().setHours(splitTime[0], splitTime[1], splitTime[2]);
  };

  const calculateHours = (shift) => {
    let timeIn = dayjs(changeTimeToDate(shift.timeOut));
    return timeIn.diff(changeTimeToDate(shift.timeIn), "hour");
  };

  const handleClickPayment = () => {
    changeGroupTap("work");
    changeTabs(11);
  };

  const renderCalculate = () => {
    if (employeeProfile.shift.workingHours) {
      var hours = employeeProfile.shift.workingHours / 60;
      if (employeeProfile.shift.breakTime === 0) {
        hours = hours - 1;
      }
      return hours;
    } else {
      return "-";
    }
  };

  const handleOpenDrawerEditPaymentRound = () => {
    setDrawerEditPaymentRoundConfig(prev => ({
      ...prev,
      isOpen: true,
      data: {},
    }))
  }

  const handleCloseDrawerEditPaymentRound = () => {
    setDrawerEditPaymentRoundConfig(prev => ({
      ...prev,
      isOpen: false,
      data: {},
    }))
  }

  return (
    <StyledRoot>
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("WorkingTimeInfo")}
        </StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            onClick={() => handleClick("charge")}
          >
            {t("Edit")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("WorkingType")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.workingType
                ? employeeProfile.workingType.toUpperCase()
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("ShiftType")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.shift
                ? employeeProfile.shift.nameShiftGroup
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("ShiftName")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.shift ? employeeProfile.shift.nameShift : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("WorkDay")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.shift ? employeeProfile.shift.workDay : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("WorkTimePerDay")}
            </StyledHeadLabel>
            <Typography variant="h6">{`${employeeProfile.shift ? renderCalculate() : " - "
              }${t("Hrs")}/${t("Days")}`}</Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("OperationFee")}(%)
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.chargeSalary
                ? `${employeeProfile.chargeSalary * 100}%`
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("OperationFee")} OT(%)
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.chargeOt
                ? `${employeeProfile.chargeOt * 100}%`
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("ChargeHireFee")}{" "}
              {`${employeeProfile.chargeHire && employeeProfile.chargeHire <= 1
                ? "(%)"
                : ""
                }`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.chargeHire
                ? employeeProfile.chargeHire <= 1
                  ? `${employeeProfile.chargeHire * 100}%`
                  : employeeProfile.chargeHire
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("ChargeCompensation")} (%)
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.chargeCompensation
                ? `${utils.numberWithCommas(employeeProfile.chargeCompensation * 100)}%`
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("ShiftCost")} (%)
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.chargeShiftCost
                ? `${employeeProfile.chargeShiftCost * 100}%`
                : "-"}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom></StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            onClick={() => {
              setDrawerEditSalaryConfig(prev => ({
                ...prev,
                isOpen: true,
                data: {
                  salaryBilling: employeeProfile.salaryBilling || "",
                  idEmployeeSalary: employeeProfile.idEmployeeSalary || null,
                }
              }))
            }}
          >
            {t("Edit")}
          </ButtonBlue>
          <ButtonBlue
            size="small"
            endIcon={<KeyboardArrowRightRoundedIcon />}
            onClick={handleClickPayment}
          >
            {t("PaymentChange")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("Salary")}
            </StyledHeadLabel>
            <div className="salary">
              <div
                className="wrap-show-hide-personalId"
                onMouseEnter={() => setShowPersonalId(true)}
                onMouseLeave={() => setShowPersonalId(false)}
              >
                {showPersonalId ? (
                  <StyledTextValue variant="h6" align="center">
                    {employeeProfile.salaryValue
                      ? utils.numberWithCommas(employeeProfile.salaryValue)
                      : "-"}
                  </StyledTextValue>
                ) : (
                  <StyledTextValue className="dot" variant="h6" align="center">
                    {[...Array(6).keys()].map((_, index) => (
                      <i key={index} class="fas fa-times"></i>
                    ))}
                  </StyledTextValue>
                )}
              </div>
              {/* <Typography color="text.secondary">
                {employeeProfile.paymentTypeName
                  ? `${t("Per")}${
                      employeeProfile.idPaymentType === 1 ||
                      employeeProfile.idPaymentType === 5
                        ? t("Day")
                        : t("Month")
                    }`
                  : "-"}
              </Typography> */}
            </div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("SalaryBilling")}
            </StyledHeadLabel>
            <div className="salary">
              <div
                className="wrap-show-hide-personalId"
                onMouseEnter={() => setShowSalaryBilling(true)}
                onMouseLeave={() => setShowSalaryBilling(false)}
              >
                {showSalaryBilling ? (
                  <StyledTextValue variant="h6" align="center">
                    {employeeProfile.salaryBilling
                      ? utils.numberWithCommas(employeeProfile.salaryBilling)
                      : "-"}
                  </StyledTextValue>
                ) : (
                  <StyledTextValue className="dot" variant="h6" align="center">
                    {[...Array(6).keys()].map((_, index) => (
                      <i key={index} class="fas fa-times"></i>
                    ))}
                  </StyledTextValue>
                )}
              </div>
              {/* <Typography color="text.secondary">
                {employeeProfile.paymentTypeName
                  ? `${t("Per")}${
                      employeeProfile.idPaymentType === 1 ||
                      employeeProfile.idPaymentType === 5
                        ? t("Day")
                        : t("Month")
                    }`
                  : "-"}
              </Typography> */}
            </div>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom></StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            // onClick={() => handleClick("paymentChange")}
            onClick={handleOpenDrawerEditPaymentRound}
          >
            {t("Edit")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("PaymentTypeName")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.salary && employeeProfile.salary.paymentTypeName
                ? employeeProfile.salary.paymentTypeName
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {t("PaymentRound")}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.roundPayment
                ? employeeProfile.roundPayment
                : "-"}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom></StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            onClick={() => handleClick("companyCharge")}
          >
            {t("Edit")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              บริษัทเจ้าของงาน(เรียกเก็บ)
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.companyChargeName
                ? employeeProfile.companyChargeName
                : "-"}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          Cost Center
        </StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            onClick={() => handleClick("cost")}
          >
            {t("Edit")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              Cost Center Charge
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.costCenterCharge
                ? employeeProfile.costCenterCharge
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              Cost Element Charge
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.costElementCharge
                ? employeeProfile.costElementCharge
                : "-"}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">IO</StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.io ? employeeProfile.io : "-"}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("BankInfo")}
        </StyledHeadLabel>
        <div>
          <ButtonBlue
            size="small"
            startIcon={<EditIcon />}
            onClick={() => handleClick("bank")}
          >
            {t("Edit")}
          </ButtonBlue>
        </div>
      </StyledWrapTop>
      <div>
        <StyledHeadLabel color="text.secondary">
          {t("BankName")}/{t("BookBankBranch")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.bookBank ? employeeProfile.bookBank : "-"}
          <Typography component="span" color="text.secondary">
            {employeeProfile.bookBankBranch
              ? ` (${employeeProfile.bookBankBranch})`
              : ""}
          </Typography>
        </Typography>
      </div>
      <div style={{ marginBottom: 16 }}>
        <StyledHeadLabel color="text.secondary">
          {t("BookBankID")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.bookBankId ? employeeProfile.bookBankId : "-"}
        </Typography>
      </div>
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("BankFiles")}
        </StyledHeadLabel>
        <div></div>
      </StyledWrapTop>
      <div>
        <StyledHeadLabel color="text.secondary">
          {t("ReportBankPayneeName")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.reportBank_Name
            ? employeeProfile.reportBank_Name
            : "-"}
        </Typography>
        <StyledHeadLabel color="text.secondary">
          {t("ReportBankName")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.reportBank_BankName
            ? employeeProfile.reportBank_BankName
            : "-"}
        </Typography>
        <StyledHeadLabel color="text.secondary">
          {t("ReportBankID")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.reportBank_BankId
            ? employeeProfile.reportBank_BankId
            : "-"}
        </Typography>
        <StyledHeadLabel color="text.secondary">
          {t("ReportBookBankID")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.reportBank_BookBankId
            ? employeeProfile.reportBank_BookBankId
            : "-"}
        </Typography>
        <StyledHeadLabel color="text.secondary">
          {t("ReportBankRef")}
        </StyledHeadLabel>
        <Typography variant="h6">
          {employeeProfile.reportBank_Ref
            ? employeeProfile.reportBank_Ref
            : "-"}
        </Typography>
      </div>
      <DialogEdit
        mode={mode}
        open={openDialog}
        handleCloseDialog={handleCloseDialog}
      />

      <DrawerEditSalary
        drawerConfig={drawerEditSalaryConfig}
        handleClose={() => {
          setDrawerEditSalaryConfig((prev) => ({
            ...prev,
            isOpen: false,
          }));
        }}
      />

      <DrawerEditPaymentRound
        drawerConfig={drawerEditPaymentRoundConfig}
        handleClose={handleCloseDrawerEditPaymentRound}
      />
    </StyledRoot>
  );
};

export default Employment;
